import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import createStringDiv from './CreateStringDiv'
import { changepositionStart,changepositionEnd,selectNewMarkerStart2, selectNewMarkerEnd2,changeNomeFermataStart,changeNomeFermataEnd, changePercorsoDrawer,changePercorsoTariffa,changePositionTariffaStart,changePositionTariffaEnd, changePolyReal,changeLineaRealTime,changeAziendaRealTime,changeRegioneAereoPartenza,changeRegioneAereoArrivo, changeLayerDrawer,changeLayerInformation,changeLayerDiv, changeArrayLayer, changeLatLongLayer,changeMappa} from "../../redux";
import { connect } from 'react-redux'
import { useEffect,useState } from "react";
import Drawer2 from '../LayerDrawer/Drawer';
import DrawerComponent from './DrawerComponent';
import ClickOnMap from './ClickOnMap';
import CreateDiv from './CreateDiv'
import './ClickOnMap.css'
import L from "leaflet";
import removeOldLayer from './RemoveOldLayer'
import { useLeaflet } from "react-leaflet";
import "leaflet.locatecontrol";
import * as WMS from "leaflet.wms";




 const   DrawerLayer = (props) =>{
 
 
  
 
  
 function ciao(props){
  
   if(props.layerDrawer.layerDrawer === true){
     
    return true;
   } else{return false;} 
 }
 let tabella = document.getElementsByClassName("tableclass")
      //if (tabella.length > 0){
       
      //}
      for(let el of tabella){el.remove()}
      let id = document.getElementById("Disponibile")
      if(id !== null){
      id.remove()
      }
 const [open, setOpen] = React.useState(false);
 
 //removeOldLayer(map)
 /* let open = false 
 props.layerDrawer.layerDrawer = true
 const Open = () =>{
   if(props.layerDrawer.layerDrawer = true){
     
      open = true
   }
   
   return open
 } */
  const RemoveDrawerLayer = () =>{
      //console.log(map,"mapdrawerlayer")
  }
 
  
 
    const handleDrawerClose = () => {
      
      props.changeLayerDrawer(false)
      let tabella = document.getElementsByClassName("tableclass")
      //if (tabella.length > 0){
       
      //}
      for(let el of tabella){el.remove()}
      let id = document.getElementById("Disponibile")
      
      if(id !== null){
        id.remove()
        }
      //RemoveDrawerLayer()
      //divApp[0].children[2].remove()
      
      //for(let el of drawer){el.remove()}
      //drawer.remove()
      
      //removeOldLayer(map);
      //removeOldLayer(map)
      //props.openMenu(false)
    //setOpen(false);
    //console.log(open,"openchiusura")
    
    
    
  };  
  

  /* const handleDrawerOpen = () => {
    setOpen(true);
    
    
  }; */
  /* var s = props.layerInformation.layerInformation;
  
var htmlObject = document.createElement('div','id');
htmlObject.innerHTML += s */


  
 /*  var div = L.DomUtil.create('div','','' )
  div.className = "informationPopUp" */
  
    return (
    
      
      
      <div className={"drawerApp"}> 
        
{/* <link openMenu={setOpen} button={props.value.buttonStyle}></link> */}
      {/* <CreateDiv openMenu={setOpen}/> */}
       {/* <ClickOnMap openMenu={setOpen} />   */}
      <Drawer
      transitionDuration={500}
        id={"LayerDrawer"}
        anchor="right"
       nome="DrawerLayer"
        open={ciao(props)}
         className={"drawer"}
        variant="persistent" 
        classes={{
          paper: "drawerPaper",
        }}
      >        
            
            <DrawerComponent data={props} callback={handleDrawerClose} />   
            
   </Drawer>
    
   </div> 
  )
   

  /* useEffect(() =>{
    try {
      if( props.layerDrawer.layerDrawer === true){
        
        //setOpen(true)
         DrawerL()
      }
    } catch (error) {
      
    }
  },[props.layerDrawer.layerDrawer]) */
  //return null
}
const mapStateToProps = state => {
  return {
      positionStart: state.positionStart,
      markerStart2: state.markerStart2,
      markerEnd2: state.markerEnd2,
      nomeFermataStart:state.nomeFermataStart,
      nomeFermataEnd: state.nomeFermataEnd,
      percorsoDrawer : state.percorsoDrawer,
      percorsoTariffa : state.percorsoTariffa,
      positionTariffaEnd : state.positionTariffaEnd,
      positionTariffaStart : state.positionTariffaStart,
      polyReal : state.polyReal,
      aziendaRealTime :state.aziendaRealTime,
      lineaRealTime:state.lineaRealTime,
      regioneAereoPartenza:state.regioneAereoPartenza,
      regioneAereoArrivo : state.regioneAereoArrivo,
      layerDrawer : state.layerDrawer,
      layerInformation : state.layerInformation,
      layerDiv : state.layerDiv,
      arrayLayer : state.arrayLayer,
        latLongLayer : state.latLongLayer,
        mappa: state.mappa

  }
}

const mapDispatchToProps = dispatch => {
  return {
      
      
      changePercorsoDrawer : (percorsoDrawer) => dispatch(changePercorsoDrawer(percorsoDrawer)),
      changePercorsoTariffa : (percorsoTariffa) => dispatch(changePercorsoTariffa(percorsoTariffa)),
      changePositionTariffaStart : (positionTariffaStart) => dispatch(changePositionTariffaStart(positionTariffaStart)),
      changePositionTariffaEnd : (positionTariffaEnd) => dispatch(changePositionTariffaEnd(positionTariffaEnd)),
      changePolyReal : (polyReal) => dispatch(changePolyReal(polyReal)),
      changeAziendaRealTime: (aziendaRealTime) => dispatch(changeAziendaRealTime(aziendaRealTime)),
      changeLineaRealTime: (lineaRealTime) => dispatch(changeLineaRealTime(lineaRealTime)),
      changeRegioneAereoPartenza : (regioneAereoPartenza) => dispatch(changeRegioneAereoPartenza(regioneAereoPartenza)),
      changeRegioneAereoArrivo : (regioneAereoArrivo) => dispatch(changeRegioneAereoArrivo(regioneAereoArrivo)),
      changeLayerDrawer : (layerDrawer) => dispatch(changeLayerDrawer(layerDrawer)),
      changeLayerInformation : (layerInformation) => dispatch(changeLayerInformation(layerInformation)),
      changeLayerDiv : (layerDiv) => dispatch(changeLayerDiv(layerDiv)),
      changeArrayLayer : (arrayLayer) => dispatch(changeArrayLayer(arrayLayer)),
        changeLatLongLayer : (latLongLayer) => dispatch(changeLatLongLayer(latLongLayer)),
        changeMappa : (mappa) => dispatch(changeMappa(mappa))

  }
}

 export  default  connect(mapStateToProps,mapDispatchToProps)(DrawerLayer) 